module.exports = {
    creating: "creating",
    waiting: "waiting",
    accepted: "accepted",
    declined: "declined",
    deleted: "deleted"
};
